import _ from 'lodash';

import { dashboard } from 'types';
import { toJSON, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  isInitialized: boolean;
  passcodes: PatronIdToPasscode;
}

export interface PatronIdToPasscode {
  [patronId: number]: string;
}

const initialState: State = {
  isInitialized: false,
  passcodes: {},
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;
  switch (type) {
    case AppConstants.PATRON_PASSCODES_FETCH_DONE: {
      const patronIdToPasscode: PatronIdToPasscode = _.reduce(
        toJSONArray<dashboard.PatronPasscode>(payload),
        (mapping: PatronIdToPasscode, passcodeEntity: dashboard.IPatronPasscode) => {
          if (passcodeEntity.patronId && passcodeEntity.passcode) {
            mapping[passcodeEntity.patronId] = passcodeEntity.passcode;
          }
          return mapping;
        },
        {}
      );
      return {
        ...state,
        isInitialized: true,
        passcodes: patronIdToPasscode,
      };
    }
    case AppConstants.PATRON_PASSCODES_DELETE_DONE: {
      const success = toJSON<boolean>(payload);
      const passcodes = { ...state.passcodes };
      if (success) {
        delete passcodes[context.patronId];
      }
      return {
        ...state,
        isInitialized: true,
        passcodes,
      };
    }
    case AppConstants.PATRON_PASSCODES_UPSERT_DONE: {
      const patronPasscode: dashboard.PatronPasscode = toJSON(payload);
      return {
        ...state,
        passcodes: { ...state.passcodes, [patronPasscode.patronId]: patronPasscode.passcode },
      };
    }
    case AppConstants.PATRON_PASSCODES_FETCH_STARTING:
    case AppConstants.PATRON_PASSCODES_UPSERT_STARTING:
    case AppConstants.PATRON_PASSCODES_DELETE_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case AppConstants.PATRON_PASSCODES_FETCH_FAILED:
    case AppConstants.PATRON_PASSCODES_UPSERT_FAILED:
    case AppConstants.PATRON_PASSCODES_DELETE_FAILED:
      return {
        ...state,
        isInitialized: true,
      };

    default:
      return state;
  }
}
